var _defs, _polygon, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRessourcesAbiotiques11 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 84.32 85.41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#081221",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "74.26 36.36 75.17 33.17 73.21 29.65 73.99 26.9 70.32 20.31 39.98 11.68 33.38 15.35 32.6 18.1 29.09 20.05 28.18 23.25 30.13 26.77 27.81 34.95 24.29 36.9 23.38 40.1 25.34 43.62 24.08 48.04 22.31 48.18 17.71 49.81 14.17 49.64 9.15 57.4 10.33 59.69 12.98 62.16 17.75 64.21 18.52 64.47 27.31 66.72 36.66 69.63 37.34 69.79 43.52 70.87 44.91 69.99 58.08 73.73 64.67 70.06 65.58 66.86 63.62 63.35 65.95 55.17 69.47 53.21 70.38 50.02 68.42 46.5 70.75 38.32 74.26 36.36",
    fill: "#ff7bae",
    filter: "url(#drop-shadow-5)",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.63,
    y: 48.89,
    width: 1.19,
    height: 1.07,
    transform: "translate(-2.34 95.75) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.67 62.78 43.93 63.05 57.79 66.99 58.11 65.85 57.09 65.56 56.81 66.52 43.67 62.78",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.43,
    y: 32.04,
    width: 1.19,
    height: 1.07,
    transform: "translate(17.35 88.13) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.11,
    y: 23.7,
    width: 1.19,
    height: 1.07,
    transform: "translate(4.08 53.86) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.31,
    y: 40.55,
    width: 1.19,
    height: 1.07,
    transform: "translate(-15.61 61.49) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.7 54.3 33.53 55 38.14 57.2 40.69 59.78 57.38 64.53 61.26 50.88 32.97 42.83 29.7 54.3",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.67 62.78 56.81 66.52 57.09 65.56 42.22 61.33 43.67 62.78",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.74,
    y: 22.96,
    width: 1.19,
    height: 1.78,
    transform: "translate(3.46 52.27) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.8,
    y: 32.08,
    width: 1.19,
    height: 1.78,
    transform: "translate(17.97 89.72) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.88,39.63l28.3,8.05,3.88-13.65-28.3-8.05-3.88,13.65ZM51.69,31.17l2.67,6.2-1.69,4.11-4.11.56-.02-.11-.07.09-3.2-2.63.67-4.41,5.75-3.8Z",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.77,
    y: 13.7,
    width: 1.19,
    height: 29.42,
    transform: "translate(10.71 71) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.95,
    y: 39.81,
    width: 1.19,
    height: 1.78,
    transform: "translate(-16.23 59.89) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.13,
    y: 9.87,
    width: 4.64,
    height: 29.42,
    transform: "translate(15.19 69.26) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.97,
    y: 30.54,
    width: 1.19,
    height: 29.42,
    transform: "translate(-8.98 78.62) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 48.93,
    width: 1.19,
    height: 1.78,
    transform: "translate(-1.72 97.35) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.21,
    y: 65.78,
    width: 1.19,
    height: 1.78,
    transform: "translate(-21.41 104.98) rotate(-74.12)",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.83 40.93 51.92 40.51 53.21 37.38 51.21 32.76 46.92 35.6 46.42 38.94 48.83 40.93",
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.53,
    y: 40.47,
    width: 14.19,
    height: 1.07,
    transform: "translate(7.51 91.94) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.74,
    y: 57.32,
    width: 14.19,
    height: 1.07,
    transform: "translate(-12.18 99.57) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.97 42.83 31.94 42.54 28.65 54.11 29.7 54.3 32.97 42.83",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.94 18.32 68.23 26.37 66.97 30.83 67.99 31.12 69.55 25.64 39.2 17 37.64 22.49 38.67 22.78 39.94 18.32",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.21,
    y: 32.12,
    width: 14.19,
    height: 1.07,
    transform: "translate(-5.77 57.68) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.41 32.64 69.08 33.78 67.37 33.3 67.08 34.32 69.82 35.1 70.73 31.9 67.99 31.12 67.7 32.15 69.41 32.64",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.52,
    y: 14.78,
    width: 1.07,
    height: 29.42,
    transform: "translate(9.44 71.49) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.14,
    y: 12.61,
    width: 1.07,
    height: 29.42,
    transform: "translate(11.98 70.5) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.32 24.17 35.64 23.03 37.35 23.51 37.64 22.49 34.91 21.71 34 24.91 36.73 25.69 37.03 24.66 35.32 24.17",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.86,
    y: 24.79,
    width: 1.07,
    height: 1.07,
    transform: "translate(2.81 54.36) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.18,
    y: 33.13,
    width: 1.07,
    height: 1.07,
    transform: "translate(16.08 88.62) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.48,
    y: 22.61,
    width: 1.07,
    height: 1.07,
    transform: "translate(5.35 53.37) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 30.96,
    width: 1.07,
    height: 1.07,
    transform: "translate(18.62 87.64) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.73,
    y: 31.63,
    width: 1.07,
    height: 29.42,
    transform: "translate(-10.24 79.11) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.61 49.48 64.29 50.63 62.58 50.14 62.29 51.17 65.02 51.95 65.93 48.75 63.2 47.97 62.91 49 64.61 49.48",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.34,
    y: 29.46,
    width: 1.07,
    height: 29.42,
    transform: "translate(-7.71 78.13) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.52 41.02 30.85 39.88 32.56 40.36 32.85 39.34 30.12 38.56 29.21 41.76 31.94 42.54 32.23 41.51 30.52 41.02",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.01,
    y: 47.81,
    width: 1.07,
    height: 1.07,
    transform: "translate(-1.07 95.26) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.39,
    y: 49.98,
    width: 1.07,
    height: 1.07,
    transform: "translate(-3.61 96.25) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.68,
    y: 39.46,
    width: 1.07,
    height: 1.07,
    transform: "translate(-14.34 61) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.07,
    y: 41.64,
    width: 1.07,
    height: 1.07,
    transform: "translate(-16.88 61.98) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.82 66.33 59.49 67.48 57.79 66.99 57.54 67.84 45.2 64.33 45.46 64.6 60.23 68.8 61.14 65.6 58.4 64.82 58.11 65.85 59.82 66.33",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.22 61.33 57.09 65.56 57.38 64.53 40.69 59.78 42.22 61.33",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.2 64.33 57.54 67.84 57.79 66.99 43.93 63.05 45.2 64.33",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.21,
    y: 64.65,
    width: 1.07,
    height: 1.07,
    transform: "translate(-20.76 102.89) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.47,42.02l.07-.09.02.11,4.11-.56,1.69-4.11-2.67-6.2-5.75,3.8-.67,4.41,3.2,2.63ZM51.21,32.76l1.99,4.62-1.29,3.13-3.09.42-2.41-1.99.51-3.34,4.29-2.84Z",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.32 55.41 28.06 56.19 28.65 54.11 24.79 53.4 19.19 55.39 14.59 55.16 15.77 57.45 20.54 59.5 29.45 61.78 38.94 64.73 45.12 65.8 45.46 64.6 24.41 58.61 25.32 55.41",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.08 56.48 29.7 54.3 28.65 54.11 28.06 56.19 29.08 56.48",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.2 59.21 27.44 58.36 25.73 57.87 26.06 56.73 27.76 57.21 28.06 56.19 25.32 55.41 24.41 58.61 45.46 64.6 45.2 64.33 27.2 59.21",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.22 61.33 40.69 59.78 29.08 56.48 28.79 57.5 42.22 61.33",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.89,
    y: 56.31,
    width: 1.07,
    height: 1.07,
    transform: "translate(-34.03 68.63) rotate(-74.12)",
    fill: "#252544",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.44 58.36 27.2 59.21 45.2 64.33 43.93 63.05 27.44 58.36",
    fill: "#252544",
    strokeWidth: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRessourcesAbiotiques11);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Ressources abiotiques-11.900df364f3702d691d51dd333f83ec41.svg";